exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2I8vt{background:rgba(0,0,0,.8)}._3pnJo{width:85%;min-width:85%;overflow:visible;border-radius:0;text-align:center}._1FcRl{padding:0;color:#000}._4ISc3{z-index:9999}", ""]);

// exports
exports.locals = {
	"modal-mobile": "_2I8vt",
	"modalMobile": "_2I8vt",
	"modal-mobile-window": "_3pnJo",
	"modalMobileWindow": "_3pnJo",
	"modal-mobile-content": "_1FcRl",
	"modalMobileContent": "_1FcRl",
	"fixed-iframe": "_4ISc3",
	"fixedIframe": "_4ISc3"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/stylus-loader??ref--2-3!./src/shared/components/modal/modal-mobile.styl
// module id = 666
// module chunks = dashboard/dashboard widget/widget mobile/mobile mobile-overlay/mobile-overlay full-screen-modals/full-screen-modals business-manager/video-library-page